module.exports = __webpack_public_path__ + "img/solution_pipe1.879983be.png";